import ArticlePush from '~/components/ArticlePush'
import Clients from '~/components/Clients'
import CurveComponent from '~/components/CurveComponent'
import EditoAlternateTextImage from '~/components/EditoAlternateTextImage'
import EditoBulletSteps from '~/components/EditoBulletSteps'
import EditoCenteredText from '~/components/EditoCenteredText'
import EditoColumnImageText from '~/components/EditoColumnImageText'
import EditoDoubleImage from '~/components/EditoDoubleImage'
import EditoPush from '~/components/EditoPush'
import EditoSliderImages from '~/components/EditoSliderImages'
import HeroMain from '~/components/HeroMain'
import ListIcons from '~/components/ListIcons'
import Quotes from '~/components/Quotes'
import Separator from '~/components/Separator'
import { MapSliceTypeToComponent } from '~/components/SliceManager'

/**
 * Homepage map slice components imports
 */
const mapSliceToComponent: MapSliceTypeToComponent = {
  article_push: ArticlePush,
  clients: Clients,
  curve_component: CurveComponent,
  edito_alternate_text_image: EditoAlternateTextImage,
  edito_bullet_steps: EditoBulletSteps,
  edito_centered_text: EditoCenteredText,
  edito_column_image_text: EditoColumnImageText,
  edito_double_image: EditoDoubleImage,
  edito_push: EditoPush,
  edito_slider_images: EditoSliderImages,
  hero_main: HeroMain,
  list_icons: ListIcons,
  quotes: Quotes,
  separator: Separator,
}

export default mapSliceToComponent
